// extracted by mini-css-extract-plugin
export var articleImage = "Collage-module--articleImage--d26d1";
export var articleLink = "Collage-module--articleLink--a0672";
export var collageSummary = "Collage-module--collageSummary--e47b9";
export var greenTileContainer = "Collage-module--greenTileContainer--10c74";
export var grid = "Collage-module--grid--be8c2";
export var listing = "Collage-module--listing--286ec";
export var newslisting = "Collage-module--newslisting--81043";